import React from 'react';
import { PropTypes } from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Dialog, Alert } from 'daaas-ui';

export default function SuccessDialog({ open = false, message, toggleDialog }) {
  const { t } = useTranslation(['dialogs', 'common']);
  return (
    <Dialog
      sx={{ zIndex: 2600 }}
      id="success-dialog"
      alert
      open={open}
      title={t('successHeading')}
      primaryButton={t('common:close')}
      handlePrimaryClick={toggleDialog}
      toggleDialog={toggleDialog}
      closeText={t('common:close')}
    >
      <Alert severity="success" role="note" closeable={false}>
        {message}
      </Alert>
    </Dialog>
  );
}

SuccessDialog.propTypes = {
  open: PropTypes.bool,
  message: PropTypes.string.isRequired,
  toggleDialog: PropTypes.func.isRequired,
};
